<div class="add_discount_modal data-table__wrap" style="height: 0; padding: 0;">
	<div class="d-flex flex-column gap-4 modal_container" id="my-store_info">
		<!-- <div class="add_discount_modal-header">
			<h3 class="fs-24 mb-0">Add delivery discount</h3>
			<svg class="closeModal" xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" >
				<path d="M24 8.5L8 24.5M8 8.5L24 24.5" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>
		</div> -->

		<form [formGroup]="form" class="fieldgroup edit w-100" (ngSubmit)="submit()" [attr.id]="formId" #formRef="ngForm">
			<div class="checked_expand_block">
				<div class="user_info_container">
					
					

					<div class="edit_opening_hours_modal" >
						<div class="d-flex flex-column gap-4 modal_container">
							<div class="add_discount_modal-header">
								<h3 class="fs-24 mb-0" i18n="@@store.specify_discount_time">Specify discount time</h3>
								<svg class="closeModal" xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" (click)="activeModal1.dismiss()">
									<path d="M24 8.5L8 24.5M8 8.5L24 24.5" stroke="#646464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</div>


							<!-- <div class="user_info_container gap-4">
								<div class="d-flex align-items-center gap-2">
									<div class="custom-checkbox">
										<input type="checkbox" checked class="select-item orders_inputAll">
										<svg class="unchecked" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
											<rect x="1" y="1" width="22" height="22" rx="3" stroke="#E0E0E0" stroke-width="2"/>
										</svg>
										<svg class="checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect x="1" y="1" width="18" height="18" rx="3" fill="#1C6AB6" stroke="#1C6AB6" stroke-width="2"/>
											<path d="M16.6667 5L7.50004 14.1667L3.33337 10" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</div>
									<div class="d-flex gap-2 align-items-start pointer fs-16">
										Set the same time for chosen days
									</div>
								</div>
								<div class="checked_expand_block" style="display: none;">
									<div class="custom_accordion-content">
										<div class="field_cont">
											from
											<div class="time-picker">
												<input type="text" class="time-input" readonly>
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
												<div class="time-dropdown" style="display: none;">
												</div>
											</div>
											to
											<div class="time-picker">
												<input type="text" class="time-input" readonly>
												<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
													<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
												</svg>
												<div class="time-dropdown" style="display: none;">
												</div>
											</div>
											<svg class="add-timePicker-field" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
												<path d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#EB1461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</div>
									</div>
								</div>
							</div> -->


							<div class="d-flex flex-column gap-4 m-0">
								<ng-container formGroupName="days">
									<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
										<div class="w-50 w-none-100">
											<ng-container formGroupName="monday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.monday">
														<div class="custom_accordion-header" (click)="openTimeModel('monday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="monday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@monday">Monday</ng-container>
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" >
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.monday">
															<div class="field_cont">
																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('monday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('monday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>

																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('monday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('monday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('monday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('monday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('monday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('monday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('monday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>
															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
										<div class="w-50 w-none-100">
											<ng-container formGroupName="tuesday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.tuesday">
														<div class="custom_accordion-header" (click)="openTimeModel('tuesday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="tuesday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@tuesday">Tuesday</ng-container>																		
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.tuesday">
															<div class="field_cont">

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('tuesday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('tuesday')">
																				<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('tuesday')" class="minutes">
																				<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('tuesday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('tuesday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('tuesday')">
																				<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('tuesday')" class="minutes">
																				<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('tuesday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('tuesday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>

															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
									</div>

									<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
										<div class="w-50 w-none-100">
											<ng-container formGroupName="wednesday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.wednesday">
														<div class="custom_accordion-header" (click)="openTimeModel('wednesday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="wednesday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@wednesday">Wednesday</ng-container>																		
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.wednesday">
															<div class="field_cont">
																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('wednesday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('wednesday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>

																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('wednesday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('wednesday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('wednesday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('wednesday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('wednesday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('wednesday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('wednesday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>
															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
										<div class="w-50 w-none-100">
											<ng-container formGroupName="thursday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.thursday">
														<div class="custom_accordion-header" (click)="openTimeModel('thursday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="thursday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@thursday">Thursday</ng-container>																		
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.thursday">
															<div class="field_cont">

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('thursday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('thursday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('thursday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('thursday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('thursday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('thursday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('thursday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('thursday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('thursday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>

															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
									</div>

									<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
										<div class="w-50 w-none-100">
											<ng-container formGroupName="friday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.friday">
														<div class="custom_accordion-header" (click)="openTimeModel('friday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="friday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@friday">Friday</ng-container>																		
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.friday">
															<div class="field_cont">
																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('friday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('friday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>

																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('friday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('friday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('friday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('friday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('friday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('friday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('friday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>
															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
										<div class="w-50 w-none-100">
											<ng-container formGroupName="saturday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.saturday">
														<div class="custom_accordion-header" (click)="openTimeModel('saturday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="saturday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@saturday">Saturday</ng-container>																		
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.saturday">
															<div class="field_cont">

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('saturday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('saturday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('saturday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('saturday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('saturday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('saturday')">
																				<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('saturday')" class="minutes">
																				<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('saturday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('saturday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>

															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
									</div>

									<div class="d-flex justify-content-between align-items-start gap-4 flex-none-column align-items-none-start">
										<div class="w-50 w-none-100">
											<ng-container formGroupName="sunday">
												<div class="custom_accordion">
													<div class="custom_accordion-item" [class.active]="timeModel.sunday">
														<div class="custom_accordion-header" (click)="openTimeModel('sunday')">
															<div class="d-flex align-items-center gap-3">
																<div class="switch-wrapper">
																	<div class="switch">
																		<input class="product-switch" type="checkbox" name="sunday" formControlName="available" >
																		<span class="slider round"></span>
																	</div>
																</div>
																<ng-container i18n="@@sunday">Sunday</ng-container>																		
															</div>
															<svg class="custom_accordion-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
																<path d="M6 9L12 15L18 9" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
														</div>

														<div class="custom_accordion-content" [class.d-none]="!timeModel.sunday">
															<div class="field_cont">
																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('sunday').get('start_time')?.invalid }">
																	<label i18n="@@store.opening_time">
																		From
																	</label>
																	<div formGroupName="new_start_time_group"  class="timing opening">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewStartTime('sunday')">
																				<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>

																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewStartTime('sunday')" class="minutes">
																				<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('sunday').get('start_time')?.errors?.required" i18n="@@error.required.opening_time">Opening time is required</span>
																</fieldset>

																<fieldset  class="half" [ngClass]="{ 'has-error': isSubmitted && getWeekDaysFormGroup('sunday').get('end_time')?.invalid }">
																	<label i18n="@@store.closing_time">
																		To
																	</label>
																	<div formGroupName="new_end_time_group"  class="timing">
																		<div class="input-wrapper">
																			<fieldset class="hours">
																				<select nice-select formControlName="hours" (change)="onChangeNewEndTime('sunday')">
																					<option *ngFor="let i of hours" [value]="i"> {{ i }} </option>
																				</select>
																				<span>H</span>
																			</fieldset>
																			<fieldset class="minutes">
																				<select nice-select formControlName="minutes" (change)="onChangeNewEndTime('sunday')" class="minutes">
																					<option *ngFor="let i of minutes" [value]="i"> {{ i }} </option>
																				</select>
																				<span>M</span>
																			</fieldset>
																		</div>
																	</div>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('sunday').get('end_time')?.errors?.required" i18n="@@error.required.closing_time">Closing time is required</span>
																	<span class="field-error" *ngIf="isSubmitted && getWeekDaysFormGroup('sunday').get('end_time')?.errors?.gte" i18n="@@error.must_be_greater_than_open_time">Must be greater than Opening Time</span>
																</fieldset>
															</div>
														</div>
													</div>
												</div>
											</ng-container>
										</div>
									</div>

								</ng-container>
							</div>

							<div class="d-flex w-100 align-items-center justify-content-end">
								<button type="submit"  class="primary_btn small closeModal w-160">
									Save
								</button>
							</div>
						</div>
					</div>



				</div>
			</div>
		</form>
	</div>
</div>